import { WrenchIcon } from "lucide-react";
import tw, { styled } from "twin.macro";

import { usePostStatusReset } from "@/api/areas/mutations";
import { Area } from "@/api/areas/types";

import { LoadingSpinner } from "./LoadingIndicator";

export type ButtonProps = {
  indigo?: boolean;
  cyan?: boolean;
  green?: boolean;
  red?: boolean;
  orange?: boolean;
  yellow?: boolean;
  white?: boolean;
  onprimary?: boolean;
  primary?: boolean;
  secondary?: boolean;
};

export const buttonStyle = {
  base: tw`transition flex items-center justify-center gap-1.5 rounded-b-xl rounded-tl-xl px-4 py-2
  text-center text-sm font-semibold
  border border-transparent
  focus:(ring-2 ring-offset-2 outline-none)
  disabled:(opacity-70 cursor-not-allowed)`,
  indigo: tw`shadow-sm bg-indigo-600 text-white hover:bg-indigo-700 focus:(ring-indigo-600)`,
  cyan: tw`shadow-sm bg-cyan-600 text-white hover:bg-cyan-700 focus:(ring-cyan-600)`,
  green: tw`shadow-sm bg-emerald-600 text-white hover:bg-emerald-700 focus:(ring-emerald-600)`,
  red: tw`shadow-sm bg-red-600 text-white hover:bg-red-700 focus:(ring-red-600)`,
  orange: tw`shadow-sm bg-orange-600 text-white hover:bg-orange-700 focus:(ring-orange-600)`,
  yellow: tw`shadow-sm bg-yellow-500 text-black hover:bg-yellow-600 focus:(ring-yellow-500)`,
  white: tw`bg-white border-gray-300 text-gray-700 hover:bg-gray-100 focus:(ring-gray-500)`,
  onPrimary: tw`bg-white border-primary-800 text-primary-800 hover:bg-primary-100 focus:(ring-primary-800)`,
  primary: tw`shadow-sm bg-primary-800 text-white hover:bg-primary-900 focus:(ring-primary-800)`,
  secondary: tw`shadow-sm bg-secondary-600 text-white hover:bg-secondary-700 focus:(ring-secondary-600)`,
};

export const Button = styled.button<ButtonProps>((props) => [
  buttonStyle.base,
  props.indigo && buttonStyle.indigo,
  props.cyan && buttonStyle.cyan,
  props.green && buttonStyle.green,
  props.red && buttonStyle.red,
  props.orange && buttonStyle.orange,
  props.yellow && buttonStyle.yellow,
  props.white && buttonStyle.white,
  props.primary && buttonStyle.primary,
  props.onprimary && buttonStyle.onPrimary,
  props.secondary && buttonStyle.secondary,
]);

export const RepairButton = ({
  postName,
  areaId,
}: {
  postName: string;
  areaId: Area["_id"];
}) => {
  const { mutateAsync: repairPost, isPending } = usePostStatusReset(areaId);

  const handleResetPostStatus = async () => {
    await repairPost({ postName });
  };
  return (
    <button
      className="group"
      tw="flex justify-center grow-0 shrink-0 w-14 cursor-pointer"
      onClick={handleResetPostStatus}
    >
      {isPending ? (
        <LoadingSpinner tw="h-4" />
      ) : (
        <WrenchIcon tw="text-gray-600 h-4 group-hover:h-5 opacity-70 group-hover:opacity-100 w-auto shrink-0" />
      )}
    </button>
  );
};
